import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { http } from "../../common/lib";
import config from "../../config";
import { actionCreators, actionTypes } from "./actions";
import { logToSentry } from "../../config/Sentry";

function* post(action) {
    const { reg } = action.payload;
    try {
        const { id } = yield select((state) => state.userOrganisations.item);
        const url = `${config.api.paths.assetLookup}`;
        const { data } = yield call(http.authorized.post, url, {
            ...reg,
            organisation: id
        });

        yield put(actionCreators.postSuccess(data));
    } catch (error) {
        logToSentry("On asset look up post:", { error });
        console.error("Asset look up post error:", error);
        yield put(actionCreators.postFailure(error));
    }
}

export default function* () {
    yield all([takeLatest(actionTypes.ASSET_LOOKUP_POST_REQUEST, post)]);
}
